import { useState } from "react";
import axios from "axios";
import './App.css';
const App = () => {
    const [records, setRecords] = useState([]);
    const [city, setCity] = useState("");

    const handleChange = (evt) => {
        setCity(evt.target.value);
    }

    const handleClick = () => {
        const adrs = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=ed59076cfa94f5d3d6d201267712c484&units=metric`;
        axios.get(adrs)
            .then((response) => {
                console.log(response);
                const temp = response.data.main.temp;
                const country=response.data.sys.country;
                const icon = response.data.weather[0].icon;
                const url = `http://openweathermap.org/img/wn/${icon}@2x.png`;
                const rcrd = [...records];
                rcrd.push({ city: city, temp: temp, url: url,country:country });
                setRecords(rcrd);
            })
            .catch((error) => {
                console.log(error);
            });
    };
    const handleDel = (i)=> {
        console.log(i);
        const rcrd = [...records];
        rcrd.splice(i,1);
        setRecords(rcrd);
    }
    console.log(records);
    return (
        <>
    
        <h2>Here you can see weather details of you city</h2>
            City Name: <input type="text" value={city} onChange={handleChange} />
            <input type="button" value="Add" onClick={handleClick} /> <hr />
            {
                records.map((row, i) => {
                    return (
                        <div key={i} className="std">
                            <img src={row.url} alt={row.city} /> <br />
                            {row.country} <br />
                            {row.city}   <br />
                            {row.temp} <br />
                            <input type="button" value="X" onClick={()=>handleDel(i)} />

                        </div>
                    )
                })
            }
        </>
    );
}
export default App;